import React, { Component } from 'react'

import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../request'
import styles from '../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { RightsWrapper } from '../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class Departments extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
    source: [],
    loading: false
  }

  apiRequest = params => {
    return new Promise(async (resolve) => {
      let data = await Request.getAllDepartments({ ...params })
      // let data = await Request.getAllShiftTimings({...params})
      this.setState({ total: data.total })
      resolve(data)
    })
  }


  handleSubmit = e => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        this.setState({ loading: true });
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateDepartment(values)
        } else {
          x = await Request.addDepartment(values)
        }
        this.setState({ loading: false });
        if (!x.error) {
          this.setState({
            id: '',
          })
          notification.success({
            message: x.message
          })
          if (!this.state.id) {
            form.setFieldsValue({
              departmentName: ''
            })
            this.setState({ activeTab: '0' })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: x.message,
            description: x.message
          })
        }
      }
    })
  }

  deleteDepartmentDetail = async (data) => {
    let response = await Request.deleteDepartment(data)
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.table.current.reload()
  }


  deleteShiftTimingDetail = async (data) => {
    let response = await Request.deleteShiftTimingDetail(data);
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.table.current.reload()
  }


  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }


  setDepartmentDetailsData(detailId) {
    if (detailId) {
      Request.getDepartmentById({ id: detailId }).then(({ data, error, message }) => {
        if (!error && data) {
          this.setState({
            id: data._id,
            activeTab: '1'
          })
          this.props.form.setFieldsValue({
            departmentName: data.departmentName
          })
        } else {
          notification.error({
            message: 'Error Getting Data',
            description: message
          })
        }
      })
    }
  }

  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  componentWillMount() {

  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const {
      form: { getFieldDecorator }
    } = this.props
    const { id } = this.state;

    const inputTypes = {
      fields: [
        {
          label: "Department Name",
          key: "departmentName",
          required: true
        }
      ]
    };

    const columns = [
      {
        title: 'Department Name',
        key: 'departmentName',
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          record.businessId ?
            <React.Fragment>
              <RightsWrapper myRight={'departments.edit'}>
                <Tooltip title="Edit Department">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    onClick={() => {
                      this.setDepartmentDetailsData(record._id)
                    }}
                    icon="edit"
                  />
                </Tooltip>
              </RightsWrapper>
              <RightsWrapper myRight={'departments.delete'}>
                <Tooltip title="Delete Department">
                  <Popconfirm
                    title="Are you sure delete this Department?"
                    onConfirm={() => {
                      this.deleteDepartmentDetail({ _id: record._id })
                    }}
                    okText="Yes"
                    cancelText="No">
                    <Button
                      className={styles.btn}
                      shape="circle"
                      icon="delete"
                    />
                  </Popconfirm>
                </Tooltip>
              </RightsWrapper>
            </React.Fragment>
            : null
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Departments `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Departments`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Department'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.state.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.state.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default Departments
